import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/*
  Generated class for the FlavorProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

export class Flavor {
  sweetValue: string;
  sweetIntValue: Number;
  sourValue: string;
  sourIntValue: Number;
  bitterValue: string;
  bitterIntValue: Number;
  hoppyValue: string;
  hoppyIntValue: Number;
  fruityValue: string;
  fruityIntValue: Number;
  maltyValue: string;
  maltyIntValue: Number;

  constructor(private translateService: TranslateService) {
    console.log("[Flavor] - constructor");

//    this.sweetValue = translateService.instant('SWEETVALUE.SWEET') + ": " + translateService.instant('SWEETVALUE.NO_VALUE');
//    this.sourValue = translateService.instant('SWEETVALUE.SOUR') + ": " + translateService.instant('SWEETVALUE.NO_VALUE');
//    this.bitterValue = translateService.instant('SWEETVALUE.BITTER') + ": " + translateService.instant('SWEETVALUE.NO_VALUE');
//    this.hoppyValue = translateService.instant('SWEETVALUE.HOPPY') + ": " + translateService.instant('SWEETVALUE.NO_VALUE');
//    this.fruityValue = translateService.instant('SWEETVALUE.FRUITY') + ": " + translateService.instant('SWEETVALUE.NO_VALUE');
//    this.maltyValue = translateService.instant('SWEETVALUE.MALTY') + ": " + translateService.instant('SWEETVALUE.NO_VALUE');
    this.sweetValue = 'SWEETVALUE.NO_VALUE';
    this.sourValue = 'SWEETVALUE.NO_VALUE';
    this.bitterValue = 'SWEETVALUE.NO_VALUE';
    this.hoppyValue = 'SWEETVALUE.NO_VALUE';
    this.fruityValue = 'SWEETVALUE.NO_VALUE';
    this.maltyValue = 'SWEETVALUE.NO_VALUE';

    this.sweetIntValue = -1;
    this.sourIntValue = -1;
    this.bitterIntValue = -1;
    this.hoppyIntValue = -1;
    this.fruityIntValue = -1;
    this.maltyIntValue = -1;
  }

  public reset(flavor: string) {
    this.setIntValue(flavor, -1);
  }


  public setIntValue(flavor: string, intValue: Number) {
    var flavorTranslation = this.translateService.instant('SWEETVALUE.' + flavor.toUpperCase())
    if (flavor === "sour") {
      this.sourValue = this.makeValue(flavorTranslation, intValue);
      this.sourIntValue = intValue;
    }
    else if (flavor === "bitter") {
      this.bitterValue = this.makeValue(flavorTranslation, intValue);
      this.bitterIntValue = intValue;
    }
    else if (flavor === "sweet") {
      this.sweetValue = this.makeValue(flavorTranslation, intValue);
      this.sweetIntValue = intValue;
    }
    else if (flavor === "hoppy") {
      this.hoppyValue = this.makeValue(flavorTranslation, intValue);
      this.hoppyIntValue = intValue;
    }
    else if (flavor === "fruity") {
      this.fruityValue = this.makeValue(flavorTranslation, intValue);
      this.fruityIntValue = intValue;
    }
    else if (flavor === "malty") {
      this.maltyValue = this.makeValue(flavorTranslation, intValue);
      this.maltyIntValue = intValue;
    }
    else {
      console.log('[Flavor] - setIntValue: illegal flavor ' + flavor);
    }
  }
  private makeValue(flavor: string, intValue: Number) {
    if (intValue == -1)
      return 'SWEETVALUE.NO_VALUE'; // flavor + ': ' + this.translateService.instant('SWEETVALUE.NO_VALUE');
    if (intValue == 0)
      return 'SWEETVALUE.ABSENT'; // flavor + ': ' + this.translateService.instant('SWEETVALUE.ABSENT');
    if (intValue == 1)
      return 'SWEETVALUE.MILD'; // flavor + ': ' + this.translateService.instant('SWEETVALUE.MILD');
    if (intValue == 2)
      return 'SWEETVALUE.MODERATE'; // flavor + ': ' + this.translateService.instant('SWEETVALUE.MODERATE');
    if (intValue == 3)
      return 'SWEETVALUE.HEAVY'; // flavor + ': ' + this.translateService.instant('SWEETVALUE.HEAVY');
    if (intValue == 4)
      return 'SWEETVALUE.DOMINANT'; // flavor + ': ' + this.translateService.instant('SWEETVALUE.DOMINANT');
    console.log('[Flavor] - makeValue: illegal intValue ' + intValue);
    return 'SWEETVALUE.UNKNOWN'; flavor + ': ' + this.translateService.instant('SWEETVALUE.UNKNOWN');
  }

}
export class FlavorProvider {

  public flavor: Flavor;

  constructor(public http: HttpClient, public translateService: TranslateService) {
    console.log('Hello FlavorProvider Provider');

    this.flavor = new Flavor(this.translateService);
  }

  public getFlavor(): Flavor {
    return this.flavor;
  }
}
